module.exports = __webpack_public_path__ + "img/cross2red.fd2c0714.png";